import * as Yup from "yup";
import { FIELD_REQUIRED_MESSAGE } from "../utils/validations";

export const lessonInitialValues = {
  userId: undefined,
  name: undefined,
  description: undefined,
  roomId: undefined,
  groupId: undefined,
  expectedAttendance: 0,
  color: "#A7BED3",
  startDate: "",
  endDate: "",
  startTime: undefined,
  duration: undefined,
  fees: "",
  capacity: "",
  days: [],
  meeting: false,
};

export const lessonValidationSchema = Yup.object({
  userId: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  name: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  roomId: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  groupId: Yup.number().optional(),
  expectedAttendance: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  color: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  startTime: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  duration: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  fees: Yup.string(),
  capacity: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  days: Yup.array().min(1, null).required(FIELD_REQUIRED_MESSAGE),
  meeting: Yup.boolean().optional(),
});

export type LessonValues = typeof lessonInitialValues;

// Definir los valores iniciales
export const holidaysInitialValues = {
  description: "",
  type: "Local",
  date: "",
  time_start: "00:00",
  time_end: "23:59",
};

// Definir el esquema de validación
export const holidaysValidationSchema = Yup.object({
  description: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  type: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  date: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  time_start: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  time_end: Yup.string().required(FIELD_REQUIRED_MESSAGE),
});

// TIMES

export const lessonTimesInitialValues = {
  hours: undefined,
  days_access: undefined,
  time_access: undefined,
};

export const lessonTimesValidationSchema = Yup.object({
  hours: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  days_access: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  time_access: Yup.number().required(FIELD_REQUIRED_MESSAGE),
});

export type LessonTimesValues = typeof lessonTimesInitialValues;

export const assistedsTimesInitialValues = {
  hours: undefined,
  assisted_anticipation_days: undefined,
  assisted_time_access: undefined,
};

export const assistedsTimesValidationSchema = Yup.object({
  hours: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  assisted_anticipation_days: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  assisted_time_access: Yup.number().required(FIELD_REQUIRED_MESSAGE),
});

export type AssistedsTimesValues = typeof assistedsTimesInitialValues;

export const lessonsCalendarInitialValues = {
  file: null,
};

export const lesssonsCalendarValidationSchema = Yup.object({
  file: Yup.mixed().required(FIELD_REQUIRED_MESSAGE),
});

export type LessonsCalendarValues = typeof lessonsCalendarInitialValues;

export const lessonProfessionalServiceInitialValues = {
  name: "",
  roomId: undefined,
  userId: undefined,
  fees: "",
  groupId: undefined,
  capacity: undefined,
  color: "#A7BED3",
  meeting: false,
  day: undefined,
  days: [],
  startTime: "",
  duration: undefined,
  startDate: "",
  endDate: "",
};

export const lessonProfessionalServiceValidationSchema = Yup.object({
  name: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  roomId: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  userId: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  fees: Yup.string(),
  groupId: Yup.number().optional(),
  capacity: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  color: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  meeting: Yup.boolean().optional(),
  days: Yup.array().min(1, null).required(FIELD_REQUIRED_MESSAGE),
  startTime: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  duration: Yup.number().required(FIELD_REQUIRED_MESSAGE),
});

export type LessonProfessionalServiceValues =
  typeof lessonProfessionalServiceInitialValues;
